/**
 * Seleção do que a home mostra de cada catálogo dinâmico. Regra pura:
 * a seção some quando a lista volta vazia (sem "em breve" na home).
 */

/** Status que a home pode anunciar; "em_desenvolvimento" fica só em /produtos. */
const SHOWCASE_PRODUCT_STATUSES = new Set(["disponivel", "beta"]);

export const HOME_SHOWCASE_LIMIT = 3;

export function selectHomeProducts<T extends { status: string; display_order: number }>(
  products: readonly T[] | null | undefined,
  limit = HOME_SHOWCASE_LIMIT,
): T[] {
  return (products ?? [])
    .filter((p) => SHOWCASE_PRODUCT_STATUSES.has(p.status))
    .sort((a, b) => a.display_order - b.display_order)
    .slice(0, limit);
}

/** Posts já vêm ordenados por `published_at desc` do hook; aqui só corta. */
export function selectLatestPosts<T>(
  posts: readonly T[] | null | undefined,
  limit = HOME_SHOWCASE_LIMIT,
): T[] {
  return (posts ?? []).slice(0, limit);
}
